import Buffer from 'buffer'

export default class BrowserFetchTransport {

	constructor (host, port = 443, timeout = 30000) {
		this.host = host
		this.port = port
		this.timeout = timeout
	}

	get origin () {
		const port_fragment = (this.port === 443 ? '' : `:${this.port}`)
		return `https://${this.host}${port_fragment}`
	}

	async request (method, resource, headers = {}, data = null, raw = false) {
		const controller = new AbortController()
		const timeout_id = setTimeout(() => controller.abort(), this.timeout)

		const request_headers = {}
		for (const [ key, value ] of Object.entries(headers)) {
			const k = key.toLowerCase()
			if (k == 'content-length' || k == 'sec-fetch-site') continue
			request_headers[key] = value
		}

		try {
			const response = await fetch(this.origin + resource, {
				method,
				headers: request_headers,
				body: data,
				signal: controller.signal
			})

			const response_headers = {}
			response.headers.forEach((value, key) => {
				response_headers[key.toLowerCase()] = value
			})

			if (!raw) {
				return {
					statusCode: response.status,
					headers: response_headers,
					body: await response.text()
				}
			}

			const body = Buffer.from(await response.arrayBuffer())
			return {
				statusCode: response.status,
				headers: response_headers,
				body
			}
		} finally {
			clearTimeout(timeout_id)
		}
	}
}
